module.exports = __webpack_public_path__ + "img/form-bg.eb82c52.webp";